<template>
	<div class="content">
		<header class="english-header">
			<div class="english-header__row">
				<button type="button" class="topic-switcher" @click="showTopics = true">
					<span class="q-title-icon" aria-hidden="true">📖</span>
					<span class="topic-switcher__name">{{ headerTitle }}</span>
					<van-icon name="arrow-down" class="topic-switcher__arrow" />
				</button>
				<div class="header-actions">
					<button type="button" class="action-btn" aria-label="新增" @click="modifyMode('add')">
						<van-icon name="add-o" />
					</button>
					<button type="button" class="action-btn" aria-label="编辑" @click="modifyMode('edit')">
						<van-icon name="records-o" />
					</button>
					<button type="button" class="action-btn action-btn--danger" aria-label="删除" @click="deleteTopic">
						<van-icon name="delete-o" />
					</button>
					<button type="button" class="action-btn action-btn--ai" @click="openAiGenerate">
						AI生成
					</button>
				</div>
			</div>
			<div v-if="!isView" class="english-header__edit-title">
				<van-field v-model="name" placeholder="输入标题" />
			</div>
		</header>
		<main :class="{ 'main--edit': !isView }">
			<div v-if="data.length === 0 && !isView" class="sentence-empty" @click="addSentence(0)">
				<van-icon name="plus" />
				<span>点击添加第一句</span>
			</div>
			<section
				class="sentence-item"
				:class="{ 'sentence-item--edit': !isView }"
				v-for="(sentence, index) in data"
				:key="sentence.id"
			>
				<div class="sentence-item__content">
					<div class="english" v-if="!isView || sentence.showEnglish">
						<span v-if="!isView" class="sentence-label">EN</span>
						<span class="role" v-if="sentence.role">{{ sentence.role }}: </span>
						<span class="sentence-text" @click="speech(sentence.english)">{{ sentence.english }}</span>
						<span class="translate-word" v-if="isView && displayType === 'E'"
							@click="translateSentence(sentence.id)">[翻译]</span>
					</div>
					<div class="chinese" v-if="!isView || sentence.showChinese">
						<span v-if="!isView" class="sentence-label sentence-label--cn">中</span>
						<span class="role" v-if="sentence.role">{{ sentence.role }}: </span>
						<span class="sentence-text">{{ sentence.chinese }}</span>
						<span class="translate-word" v-if="isView && displayType === 'C'"
							@click="translateSentence(sentence.id)">[翻译]</span>
					</div>
				</div>
				<div class="sentence-item__operate-buttons" v-if="!isView">
					<button type="button" class="sentence-op-btn" aria-label="在后面插入" @click="addSentence(index + 1)">
						<van-icon name="plus" />
					</button>
					<button type="button" class="sentence-op-btn sentence-op-btn--delete" aria-label="删除" @click="deleteSentence(sentence.id)">
						<van-icon name="cross" />
					</button>
				</div>
			</section>
			<div class="edit-footer" v-if="!isView">
				<van-button plain hairline type="default" @click="cancelModify">取消</van-button>
				<van-button type="primary" @click="submitTopic">{{ mode === 'add' ? '添加' : '更新' }}</van-button>
			</div>
		</main>
		<div class="custom-toggle-button" v-if="isView" @click="toggleLanguage">
			<van-icon name="replay" size="20px" />
			{{ displayTypeName }}
		</div>
		<van-dialog v-model="showAddSentence" title="添加对话" showCancelButton :beforeClose="beforeClose">
			<van-field v-model="enitRole" label-width="36" label="角色" placeholder="请输入角色名称" />
			<van-field v-model="editEnglish" label-width="36" rows="2" autosize label="英文" type="textarea"
				placeholder="请输入英文" />
			<van-field v-model="editChinese" label-width="36" rows="2" autosize label="中文" type="textarea"
				placeholder="请输入中文" />
		</van-dialog>
		<van-dialog v-model="showTopics" showCancelButton :showConfirmButton="false">
			<div class="topic-list">
				<span v-for="topic in topics" :key="topic.id" @click="openTopic(topic.id)">{{ topic.name }}</span>
			</div>

		</van-dialog>

		<van-dialog v-model="showAiGenerate" title="AI 生成对话" showCancelButton
			:showConfirmButton="false" class="ai-generate-dialog" @open="onAiGenerateOpen">
			<div class="ai-dialog-body">
				<div class="ai-suggest-header">
					<span class="ai-suggest-title">推荐主题</span>
					<van-button size="mini" plain type="primary" :loading="suggestLoading"
						@click="loadTopicSuggestions(true)">换一批</van-button>
				</div>
				<div class="ai-suggest-tags" v-if="suggestLoading && !suggestedTopics.length">
					<van-loading size="20px">加载中...</van-loading>
				</div>
				<div class="ai-suggest-tags" v-else>
					<van-tag v-for="(item, index) in suggestedTopics" :key="`${item.theme}-${index}`"
						plain type="primary" round class="ai-theme-tag" @click="selectSuggestedTheme(item.theme)">
						{{ item.theme }}
						<span v-if="item.hint" class="ai-theme-hint"> · {{ item.hint }}</span>
					</van-tag>
				</div>

				<van-field v-model="aiForm.theme" label="主题" required placeholder="如：餐厅点餐" />
				<van-field label="难度">
					<template #input>
						<van-radio-group v-model="aiForm.level" direction="horizontal" @change="onAiLevelChange">
							<van-radio name="intermediate">中级</van-radio>
							<van-radio name="advanced">高级</van-radio>
						</van-radio-group>
					</template>
				</van-field>
				<van-field label="句数">
					<template #input>
						<van-stepper v-model="aiForm.sentenceCount" min="4" max="16" integer />
					</template>
				</van-field>
				<van-field v-model="aiForm.roleA" label="角色A" placeholder="如：服务员" />
				<van-field v-model="aiForm.roleB" label="角色B" placeholder="如：顾客" />
				<van-field v-model="aiForm.note" label="补充" type="textarea" rows="2" autosize
					placeholder="可选，如：句子短一点" />
				<div class="ai-generate-actions">
					<van-button type="primary" block :loading="generateLoading" @click="generateDialogue">
						生成对话
					</van-button>
				</div>
			</div>
		</van-dialog>

		<van-dialog v-model="showAiPreview" title="预览对话" showCancelButton confirmButtonText="填入编辑"
			@confirm="applyAiPreview">
			<div class="ai-preview-body" v-if="aiPreview">
				<div class="ai-preview-title">{{ aiPreview.title }}</div>
				<div class="ai-preview-item" v-for="(sentence, index) in aiPreview.sentences" :key="index">
					<div class="ai-preview-role">{{ sentence.role }}</div>
					<div>{{ sentence.english }}</div>
					<div class="ai-preview-chinese">{{ sentence.chinese }}</div>
				</div>
				<van-button plain type="primary" size="small" block :loading="generateLoading"
					@click="regenerateDialogue">重新生成</van-button>
			</div>
		</van-dialog>
	</div>
</template>

<script>
import {
	getTopic,
	updateTopic,
	deleteTopic,
	getTopicNameList,
	generateEnglishDialogue,
	getEnglishTopicSuggestions
} from '../util/api'
import { Notify } from 'vant';
import { v4 as uuidv4 } from 'uuid';
import { Dialog } from 'vant';
export default {
	name: 'English-Study',
	data() {
		return {
			showAddSentence: false,
			showTopics: false,
			showAiGenerate: false,
			showAiPreview: false,
			suggestLoading: false,
			generateLoading: false,
			suggestedTopics: [],
			aiPreview: null,
			aiForm: {
				theme: '',
				level: 'intermediate',
				sentenceCount: 8,
				roleA: 'A',
				roleB: 'B',
				note: ''
			},
			presetTopicsFallback: {
				intermediate: [
					{ theme: '餐厅点餐', hint: '点餐与结账' },
					{ theme: '超市购物', hint: '询价与找商品' },
					{ theme: '机场问路', hint: '登机与转机' },
					{ theme: '投诉上错菜', hint: '礼貌表达问题' },
					{ theme: '讨论旅行计划', hint: '商量行程' },
					{ theme: '幼儿园接送', hint: '与老师沟通' }
				],
				advanced: [
					{ theme: '商务会议延期', hint: '正式说明与协商' },
					{ theme: '租房谈条款', hint: '押金与维修责任' },
					{ theme: '工作汇报', hint: '进展与风险' },
					{ theme: '面试深度问答', hint: '经历与动机' },
					{ theme: '育儿观念分歧', hint: '委婉表达观点' },
					{ theme: '医疗方案咨询', hint: '问清利弊' }
				]
			},
			data: [
			],
			originalData: [],
			name: null,
			enitRole: null,
			editEnglish: null,
			editChinese: null,
			insertIndex: 0,
			displayType: 'E',  // A E C
			mode: "view",  //add, edit,view
			currentTopic: null,
			currentTopicId: null,
			topics: []
		}
	},
	methods: {
		openAiGenerate() {
			if (this.mode === 'edit') {
				Dialog.confirm({
					message: '将放弃当前编辑，继续 AI 生成吗？'
				}).then(() => {
					this.showAiGenerate = true
				}).catch(() => { });
				return
			}
			this.showAiGenerate = true
		},
		onAiGenerateOpen() {
			this.loadTopicSuggestions(false)
		},
		onAiLevelChange() {
			this.loadTopicSuggestions(false)
		},
		getExcludeTopicNames() {
			return (this.topics || []).map((t) => t.name).filter(Boolean)
		},
		selectSuggestedTheme(theme) {
			this.aiForm.theme = theme
		},
		loadTopicSuggestions(refresh = false) {
			this.suggestLoading = true
			getEnglishTopicSuggestions({
				level: this.aiForm.level,
				refresh,
				exclude: this.getExcludeTopicNames()
			}).then((res) => {
				const topics = res?.data?.data?.topics
				if (Array.isArray(topics) && topics.length) {
					this.suggestedTopics = topics
				} else {
					this.suggestedTopics = this.presetTopicsFallback[this.aiForm.level] || this.presetTopicsFallback.intermediate
				}
			}).catch(() => {
				this.suggestedTopics = this.presetTopicsFallback[this.aiForm.level] || this.presetTopicsFallback.intermediate
			}).finally(() => {
				this.suggestLoading = false
			})
		},
		buildAiPayload() {
			return {
				theme: this.aiForm.theme,
				level: this.aiForm.level,
				sentenceCount: this.aiForm.sentenceCount,
				roles: [this.aiForm.roleA || 'A', this.aiForm.roleB || 'B'],
				note: this.aiForm.note
			}
		},
		generateDialogue() {
			if (!this.aiForm.theme || !String(this.aiForm.theme).trim()) {
				Notify({ type: 'danger', message: '请输入或选择主题' });
				return
			}
			this.generateLoading = true
			generateEnglishDialogue(this.buildAiPayload()).then((res) => {
				if (res?.data?.code !== 0) {
					Notify({ type: 'danger', message: res?.data?.message || '生成失败，请重试' });
					return
				}
				this.aiPreview = res?.data?.data || null
				if (this.aiPreview) {
					this.showAiGenerate = false
					this.showAiPreview = true
				}
			}).catch((err) => {
				const timedOut = err?.code === 'ECONNABORTED' || String(err?.message || '').includes('timeout')
				Notify({
					type: 'danger',
					message: timedOut ? '生成超时，请稍后重试（AI 响应较慢）' : '生成失败，请重试'
				});
			}).finally(() => {
				this.generateLoading = false
			})
		},
		regenerateDialogue() {
			this.generateDialogue()
		},
		applyAiPreview() {
			if (!this.aiPreview) return
			this.mode = 'add'
			this.name = this.aiPreview.title
			this.data = (this.aiPreview.sentences || []).map((s) => ({
				id: uuidv4(),
				role: s.role,
				english: s.english,
				chinese: s.chinese,
				isNew: true,
				showEnglish: true,
				showChinese: true
			}))
			this.showAiPreview = false
			this.setDisplayType(this.displayType || 'A')
		},
		speech(english) {
			const speech = new SpeechSynthesisUtterance(english);
            speech.lang = 'en-US';
            window.speechSynthesis.speak(speech);
		},
		translateSentence(id) {
			this.data = this.data.map((sentence) => {
				if (sentence.id === id) {
					if (this.displayType === 'E') {
						sentence.showChinese = !sentence.showChinese
					}
					if (this.displayType === 'C') {
						sentence.showEnglish = !sentence.showEnglish
					}
				}
				return sentence
			})
		},
		toggleLanguage() {
			const language = ['A', 'E', 'C']
			const index = language.findIndex((l) => this.displayType === l)
			this.displayType = language[(index + 1) % language.length]
		},
		getTopicNameList() {
			return getTopicNameList().then((res) => {
				this.topics = res?.data || []
			})
		},
		initPage() {
			this.getTopicNameList().then(() => {
				const topics = this.topics || []
				const hasCurrent = topics.some((t) => String(t.id) === String(this.currentTopicId))
				if (!hasCurrent && topics.length) {
					this.currentTopicId = topics[0].id
				}
				if (this.currentTopicId) {
					this.getTopic()
				}
			})
		},
		openTopic(id) {
			this.currentTopicId = id;
			this.getTopic();
			this.showTopics = false
		},
		deleteTopic() {
			Dialog.confirm({
				message: `确认删除${this.currentTopic.name}吗`
			}).then(() => {
				deleteTopic({
					id: this.currentTopic.id
				}).then(() => {
					const displayTopicId = this.topics.find((topic) => topic.id !== this.currentTopic.id).id
					this.currentTopicId = displayTopicId;
					this.getTopic();
					this.getTopicNameList();
				})
			}).catch(() => {
				// on cancel
			});
		},
		getTopic() {
			if (!this.currentTopicId) return
			getTopic({ id: this.currentTopicId }).then((res) => {
				const data = res?.data
				if (!data || Array.isArray(data) || data.id == null) {
					this.name = null
					this.data = []
					this.currentTopic = null
					return
				}
				this.originalData = JSON.parse(JSON.stringify(data))
				this.currentTopic = data
				this.resolveData(data)
			})
		},
		modifyMode(mode) {
			if (mode === 'add') {
				this.data = []
				this.currentTopic = null;
				this.name = null
			} else if (mode === 'edit') {
				if (!this.currentTopic) {
					if (this.originalData && this.originalData.id) {
						this.currentTopic = JSON.parse(JSON.stringify(this.originalData))
					} else if (this.currentTopicId) {
						this.currentTopic = { id: this.currentTopicId }
					}
				}
				if (!this.currentTopic?.id && !this.currentTopicId) {
					Notify({ type: 'danger', message: '请先选择要编辑的对话' });
					return
				}
			}
			this.mode = mode
		},
		deleteSentence(id) {
			this.data = this.data.filter((sentence) => sentence.id !== id)
		},
		addSentence(insertIndex) {
			this.insertIndex = insertIndex
			this.showAddSentence = true
		},
		beforeClose(action, done) {
			if (action === 'confirm') {
				if (this.editEnglish && this.editChinese) {
					this.addSentenceToData()
					done()
				} else {
					Notify({ type: 'danger', message: this.editEnglish ? '请输入中文' : '请输入英文' });
					done(false)
				}
			} else {
				done();
			}
		},
		addSentenceToData() {
			this.data.splice(this.insertIndex, 0, {
				chinese: this.editChinese,
				english: this.editEnglish,
				role: this.enitRole,
				id: uuidv4(),
				isNew: true
			})
			this.clearAddData()
		},
		clearAddData() {
			this.editEnglish = null
			this.editChinese = null
			this.enitRole = null
		},
		cancelModify() {
			this.mode = 'view'
			this.resolveData(JSON.parse(JSON.stringify(this.originalData)))
		},
		submitTopic() {
			const newSentences = JSON.stringify(this.data.filter((sentence) => sentence.isNew))
			const topic = {
				name: this.name,
				content: JSON.stringify(this.data.map((item) => item.id)),
				update_time: new Date().toLocaleString(),
				newSentences
			}
			if (!this.name) {
				Notify({ type: 'danger', message: '请输入标题' });
				return
			}
			if (this.mode === 'edit') {
				const topicId = this.currentTopic?.id ?? this.currentTopicId
				if (!topicId) {
					Notify({ type: 'danger', message: '请先选择要编辑的对话' });
					return
				}
				topic.id = topicId
			}
			updateTopic(topic).then((res) => {
				if (res?.data?.topicId) {
					if (this.mode === 'add') {
						this.getTopicNameList();
					}
					this.mode = 'view'
					this.currentTopicId = res.data.topicId
					this.getTopic()
				}
			})
		},
		resolveData(data) {
			if (!data || Array.isArray(data)) {
				this.data = []
				return
			}
			const { name, content, sentences } = data
			let sentencesId = []
			if (content != null && content !== '') {
				try {
					const parsed = JSON.parse(content)
					sentencesId = Array.isArray(parsed) ? parsed : []
				} catch (e) {
					sentencesId = []
				}
			}
			this.name = name
			this.data = sentencesId
				.map((id) => (sentences || []).find((sentence) => sentence.id === id))
				.filter(Boolean)
			if (!this.displayType) {
				this.displayType = 'A'
			}
			this.setDisplayType(this.displayType)
		},
		setDisplayType(type) {
			const safeType = ['A', 'E', 'C'].includes(type) ? type : 'A'
			this.data = (this.data || []).map((sentence) => ({
				...sentence,
				showEnglish: ['A', 'E'].includes(safeType),
				showChinese: ['A', 'C'].includes(safeType)
			}))
		}
	},
	beforeMount() {
		if (this.$route.query.id) {
			this.currentTopicId = this.$route.query.id
		}
	},
	mounted() {
		this.initPage()
	},
	computed: {
		isView() {
			return this.mode === 'view'
		},
		headerTitle() {
			if (!this.isView) {
				return this.mode === 'add' ? '新建对话' : '编辑对话'
			}
			return this.name || '选择对话'
		},
		displayTypeName() {
			let name
			switch (this.displayType) {
				case 'E':
					name = '英';
					break;
				case 'C':
					name = '中';
					break;
				default:
					name = '全';
			}
			return name
		}
	},
	watch: {
		displayType(newVal) {
			this.setDisplayType(newVal)
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	position: relative;
	/* Q版：柔和底色 + 贴纸卡片 */
	--q-bg0: #fff7fb;
	--q-bg1: #f2fbff;
	--q-card: rgba(255, 255, 255, 0.92);
	--q-line: rgba(15, 23, 42, 0.08);
	--q-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);
	--q-shadow-sm: 0 6px 14px rgba(17, 24, 39, 0.08);
	--q-radius: 18px;
	--q-primary: #34c3ff;
	--q-primary-2: #6ee7ff;
	--q-danger: #ff5f7a;

	padding: 14px 14px 18px;
	display: flex;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
	font-size: 14px;
	font-family: "Comic Sans MS", "Microsoft YaHei UI", "PingFang SC", "Hiragino Sans GB", system-ui, -apple-system,
		BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
	background: radial-gradient(120% 90% at 20% 0%, var(--q-bg0) 0%, transparent 60%),
		radial-gradient(120% 90% at 90% 30%, var(--q-bg1) 0%, transparent 55%),
		#ffffff;
}

.content::before,
.content::after {
	content: "";
	position: fixed;
	z-index: -1;
	pointer-events: none;
	opacity: 0.9;
}
.content::before {
	width: 240px;
	height: 240px;
	left: -90px;
	top: 140px;
	background: radial-gradient(circle at 30% 30%, rgba(255, 184, 220, 0.55), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(110, 231, 255, 0.45), transparent 62%);
	border-radius: 999px;
}
.content::after {
	width: 280px;
	height: 280px;
	right: -140px;
	bottom: 90px;
	background: radial-gradient(circle at 40% 30%, rgba(196, 255, 214, 0.5), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(255, 224, 170, 0.45), transparent 62%);
	border-radius: 999px;
}
/* 不要对 `.content > *` 统一加 position/z-index，会破坏 Vant Dialog/Popup 的 fixed 布局 */

.english-header {
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
	padding: 10px 12px;
	margin-bottom: 8px;
	flex-shrink: 0;
}

.english-header__row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	min-width: 0;
}

.topic-switcher {
	flex: 1;
	min-width: 0;
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 4px 6px 4px 2px;
	margin: 0;
	border: 0;
	background: transparent;
	cursor: pointer;
	text-align: left;
	font: inherit;
	color: inherit;
}

.q-title-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	flex-shrink: 0;
	border-radius: 8px;
	background: rgba(52, 195, 255, 0.16);
	box-shadow: 0 6px 14px rgba(52, 195, 255, 0.16);
	transform: rotate(-6deg);
	font-size: 12px;
	line-height: 1;
}

.topic-switcher__name {
	flex: 1;
	min-width: 0;
	font-size: 15px;
	font-weight: 800;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.topic-switcher__arrow {
	flex-shrink: 0;
	font-size: 14px;
	color: rgba(47, 52, 64, 0.45);
}

.header-actions {
	display: flex;
	align-items: center;
	gap: 6px;
	flex-shrink: 0;
}

.action-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 0;
	margin: 0;
	border: 1px solid rgba(15, 23, 42, 0.08);
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.92);
	color: rgba(47, 52, 64, 0.88);
	cursor: pointer;
	font: inherit;
	line-height: 1;
	box-shadow: 0 4px 10px rgba(17, 24, 39, 0.06);
}

.action-btn /deep/ .van-icon {
	font-size: 18px;
}

.action-btn:active {
	transform: translateY(1px) scale(0.98);
}

.action-btn--danger {
	background: rgba(255, 95, 122, 0.1);
	color: var(--q-danger);
	border-color: rgba(255, 95, 122, 0.18);
}

.action-btn--ai {
	width: auto;
	min-width: 32px;
	height: 32px;
	padding: 0 10px;
	border: none;
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
	color: #fff;
	font-size: 11px;
	font-weight: 800;
	letter-spacing: 0.2px;
	box-shadow: 0 6px 14px rgba(52, 195, 255, 0.28);
}

.english-header__edit-title {
	margin-top: 8px;
	padding-top: 8px;
	border-top: 1px dashed rgba(15, 23, 42, 0.1);
}

.english-header__edit-title /deep/ .van-cell {
	padding: 4px 0;
	background: transparent;
}

.english-header__edit-title /deep/ .van-field__control {
	font-size: 14px;
	font-weight: 700;
}

main {
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: rgba(255, 255, 255, 0.86);
	box-shadow: var(--q-shadow-sm);
	padding: 10px 12px;
	flex: 1;
	min-height: 0;
	overflow-y: auto;
}

.main--edit {
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding-bottom: 12px;
}

.sentence-empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
	min-height: 120px;
	border: 1px dashed rgba(52, 195, 255, 0.35);
	border-radius: 14px;
	background: rgba(52, 195, 255, 0.06);
	color: rgba(47, 52, 64, 0.72);
	font-size: 13px;
	font-weight: 700;
	cursor: pointer;
}

.sentence-empty /deep/ .van-icon {
	font-size: 28px;
	color: var(--q-primary);
}

.sentence-item--edit {
	align-items: stretch;
	padding: 10px 10px 10px 12px;
	border: 1px solid rgba(15, 23, 42, 0.08);
	border-radius: 14px;
	background: rgba(255, 255, 255, 0.96);
	box-shadow: 0 6px 14px rgba(17, 24, 39, 0.05);
	margin-bottom: 0;
}

.sentence-item--edit .english,
.sentence-item--edit .chinese {
	display: flex;
	align-items: flex-start;
	gap: 6px;
	line-height: 1.5;
}

.sentence-item--edit .english {
	margin-bottom: 6px;
}

.sentence-label {
	flex-shrink: 0;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 24px;
	height: 20px;
	padding: 0 6px;
	border-radius: 6px;
	font-size: 10px;
	font-weight: 800;
	color: var(--q-primary);
	background: rgba(52, 195, 255, 0.14);
}

.sentence-label--cn {
	color: #ff6b84;
	background: rgba(255, 107, 132, 0.12);
}

.sentence-text {
	flex: 1;
	min-width: 0;
	word-break: break-word;
}

.sentence-item__operate-buttons {
	width: auto;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding-left: 8px;
	flex-shrink: 0;
}

.sentence-op-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 0;
	border: 1px solid rgba(15, 23, 42, 0.08);
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.95);
	color: rgba(47, 52, 64, 0.82);
	cursor: pointer;
	box-shadow: 0 4px 10px rgba(17, 24, 39, 0.06);
}

.sentence-op-btn /deep/ .van-icon {
	font-size: 16px;
}

.sentence-op-btn--delete {
	color: var(--q-danger);
	background: rgba(255, 95, 122, 0.1);
	border-color: rgba(255, 95, 122, 0.18);
}

.edit-footer {
	display: flex;
	gap: 10px;
	margin-top: auto;
	padding-top: 4px;
}

.edit-footer /deep/ .van-button {
	flex: 1;
	height: 40px;
	font-weight: 700;
}

.edit-footer /deep/ .van-button--primary {
	border: none;
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
	box-shadow: 0 8px 18px rgba(52, 195, 255, 0.24);
}

.content /deep/ .van-dialog {
	border-radius: 18px;
	overflow: hidden;
}
.content /deep/ .van-dialog__confirm {
	border: none;
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
	color: #fff;
	font-weight: 800;
}
.content /deep/ .van-dialog__cancel {
	color: rgba(47, 52, 64, 0.9);
	font-weight: 700;
}
.content /deep/ .van-button {
	border-radius: 999px;
}
.content /deep/ .van-button--danger {
	border: none;
	background: linear-gradient(180deg, #ff6b84 0%, var(--q-danger) 100%);
	box-shadow: 0 8px 18px rgba(255, 95, 122, 0.22);
	color: #fff;
}

section {
	margin-bottom: 18px;
}

.role {
	font-weight: bold;
}

.english {
	margin-bottom: 2px;
}

.ai-dialog-body {
	padding: 8px 16px 16px;
	max-height: 70vh;
	overflow-y: auto;
}

.ai-suggest-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 8px;
}

.ai-suggest-title {
	font-weight: 700;
	font-size: 13px;
}

.ai-suggest-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 12px;
	min-height: 28px;
}

.ai-theme-tag {
	cursor: pointer;
}

.ai-theme-hint {
	opacity: 0.75;
	font-size: 11px;
}

.ai-generate-actions {
	margin-top: 12px;
}

.ai-preview-body {
	padding: 8px 16px 16px;
	max-height: 65vh;
	overflow-y: auto;
}

.ai-preview-title {
	font-weight: 800;
	text-align: center;
	margin-bottom: 12px;
}

.ai-preview-item {
	margin-bottom: 12px;
	padding-bottom: 10px;
	border-bottom: 1px dashed rgba(15, 23, 42, 0.12);
}

.ai-preview-role {
	font-weight: 700;
	margin-bottom: 4px;
}

.ai-preview-chinese {
	color: rgba(47, 52, 64, 0.75);
	margin-top: 4px;
}

.sentence-item {
	display: flex;
	align-items: center;
	word-break: break-word;
	gap: 8px;
}

.sentence-item__content {
	flex: 1;
	min-width: 0;
}

.custom-toggle-button {
	position: absolute;
	bottom: 18%;
	right: 10px;
	display: inline-flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 4px;
	width: 46px;
	height: 56px;
	font-size: 12px;
	font-weight: 900;
	color: rgba(47, 52, 64, 0.92);
	border-radius: 18px;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 255, 255, 0.72) 100%);
	border: 1px solid rgba(15, 23, 42, 0.10);
	box-shadow:
		0 14px 26px rgba(17, 24, 39, 0.14),
		0 6px 14px rgba(52, 195, 255, 0.10);
	user-select: none;
	cursor: pointer;
}

.custom-toggle-button::before {
	/* 顶部糖果色小帽子 */
	content: "";
	position: absolute;
	top: -7px;
	left: 50%;
	transform: translateX(-50%);
	width: 28px;
	height: 10px;
	border-radius: 999px;
	background: linear-gradient(90deg, rgba(52, 195, 255, 0.95), rgba(255, 107, 132, 0.85));
	box-shadow: 0 10px 18px rgba(255, 107, 132, 0.16);
}

.custom-toggle-button::after {
	/* 贴纸高光 */
	content: "";
	position: absolute;
	inset: 5px;
	border-radius: 16px;
	background: radial-gradient(circle at 30% 20%, rgba(255, 255, 255, 0.85), transparent 55%);
	opacity: 0.7;
	pointer-events: none;
}

.custom-toggle-button /deep/ .van-icon {
	color: rgba(14, 165, 233, 0.95);
	filter: drop-shadow(0 6px 10px rgba(52, 195, 255, 0.18));
}

.custom-toggle-button:active {
	transform: translateY(1px) scale(0.99);
}

.translate-word {
	font-size: 12px;
	margin-left: 4px;
	color: #0020e2;
}

.topic-list {
	padding: 16px 16px 10px;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 10px;
	max-height: 60vh;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	box-sizing: border-box;
}

.topic-list span {
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 12px 12px;
	border-radius: 14px;
	border: 1px solid rgba(15, 23, 42, 0.10);
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 255, 255, 0.78) 100%);
	box-shadow: 0 10px 18px rgba(17, 24, 39, 0.10);
	font-weight: 800;
	letter-spacing: 0.2px;
	user-select: none;
	cursor: pointer;
}

.topic-list span:active {
	transform: translateY(1px) scale(0.99);
}
</style>
